<template>
  <div>
    <div class="title">
      <span>团队生活</span>
    </div>
    <div class="table">
      <div class="item" v-for="item in teamLifeList" :key="item.id">
        <el-card :body-style="{ padding: '0px' }">
          <div @click="routerTo(`/detail`, item)">
            <img
            :src="item.image"
            class="image"
          />
          <div class="Stitle" style="padding: 14px">
            <span>{{ item.title }}</span>
            <div class="bottom clearfix">
              <time class="time">{{ item.createdTime | formatDate("YYYY-MM-DD") }}</time>
              <el-button type="text" class="button">查看详情</el-button>
            </div>
          </div>
          </div>
        </el-card>
      </div>
    </div>
    <!-- <div class="pagination">
      <el-pagination
        @current-change="currentChange"
        :total="total"
        :current-page="currPage"
        :page-size="pageSize"
        layout="prev, pager, next"
      >
      </el-pagination>
    </div> -->
  </div>
</template>

<script>
import {getTeamLifePage} from '@/api/api'
export default {
  data () {
    return {
      type: '',
      total: 1000,
      currPage: 1,
      pageSize: 99999,
      teamLifeList: []
    }
  },
  created () {
    const type = this.$route.query.type
    console.log(type)
    this.type = type
    this.getTeamLifePage()
  },
  methods: {
    routerTo (path, row) {
      sessionStorage.detail = JSON.stringify(row)
      this.$router.push({
        path
      })
    },
    // 页码切换时触发
    currentChange (e) {
      console.log(e)
      this.currPage = e
      this.getNoticePage()
    },
    getTeamLifePage () {
      let data = {
        pageSize: this.pageSize,
        currPage: this.currPage
      }
      getTeamLifePage(data).then(res => {
        if (res.code === 200) {
          this.teamLifeList = res.data.list
          this.total = res.data.totalCount
        }
      })
    }
  }
}
</script>

  <style scoped>
.title {
  letter-spacing: 1px;
  font-size: 28px;
  line-height:2em;
  color: #2f4f4f;
  border-bottom: 3px solid #2f4f4f;
  font-weight: bold;
}
.serch {
  margin-top: 20px;
}
</style>
  <style scoped>
.table {
  /* border: 3px solid #2F4F4F;
    padding: 20px;
    box-sizing: border-box; */
    display: flex;
    flex-wrap: wrap;
}
.item {
  /* height: 40px; */
  margin: 20px;
  width: 330px;
}
.item:hover {
  cursor: pointer;
  color: #d4af37;
}
.pagination {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}
.time {
    font-size: 13px;
    color: #999;
  }
  .bottom {
    margin-top: 13px;
    line-height: 12px;
  }

  .button {
    padding: 0;
    float: right;
  }

  .image {
    width:330px;
    height: 219px;
    display: block;
    object-fit:cover;
  }

  .clearfix:before,
  .clearfix:after {
      display: table;
      content: "";
  }
  .clearfix:after {
      clear: both
  }
  .Stitle{
    /* height: 100px; */
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
</style>



// WEBPACK FOOTER //
// src/view/groupAlbum.vue